module.exports = __webpack_public_path__ + "images/embed/ms_filter_surround_large.gif";